<template>
  <v-card class="cart-container" style="height: 100% !important">
    <v-card-text class="pt-1 pl-0 pr-0" style="height: 100% !important">
      <template>
        <v-row class="pl-3 pr-3">
          <v-col cols="6" class="pt-3 pb-3">
            <v-text-field
              ref="order_number"
              v-model="last_order_code_solicitud"
              label="Número de Orden"
              outlined
              hide-details
              @keydown="handleInputSearchOrderCode"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pt-3 pb-3">
            <v-menu
              v-model="menuDateInvoice"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="order_date"
                  :value="date_invoice"
                  label="Fecha"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                :value="date_invoice"
                @input="menuDateInvoice = false"
                no-title
                locale="es"
                @change="set_date_invoice"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <hr class="separator-line" v-if="selected_station && worker == null" />
        <v-row class="pl-3 pr-3" v-if="selected_station && worker == null">
          <v-col cols="11" class="pb-4">
            <v-autocomplete
              :value="worker_id"
              :items="workers"
              label="Trabajador"
              hide-details
              outlined
              :item-text="customTextWorkers"
              item-value="id"
              clearable
              @change="handleSelectWorker"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="pl-3 pr-3" v-if="worker">
          <v-col cols="12" class="pt-0 pb-0">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="blue" class="mr-2" size="18">
                      fas fa-user-cog
                    </v-icon>
                    <span
                      class="
                        text-uppercase
                        font-weight-bold
                        cart-label-customer
                      "
                      >{{ worker.fullname }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="ml-8">{{ worker.payment_type }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearWorker" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <hr class="separator-line" />

        <!--Paciente-->
        <v-row class="pl-3 pr-3">
          <v-col cols="11" class="pb-3" v-if="customer == null">
            <v-autocomplete
              ref="customer_id"
              :items="customers"
              label="Paciente"
              outlined
              :item-text="customTextPaciente"
              item-value="id"
              clearable
              :value="customer_id"
              :loading="isLoading"
              @change="handleSelectCustomer"
              :filter="customFilter"
              v-on:keyup.enter="searchPaciente($event)"
              :rules="[
                () => !!customer_id || 'Es necesario seleccionar un Paciente',
              ]"
              hide-details="auto"
              required
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.surname + " " + data.item.name
                  }}</v-list-item-title>
                  <v-list-item-subtitle v-if="data.item.type_document_id">
                    {{ data.item.type_document.name }}: {{ data.item.document }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <!-- <v-autocomplete
              :value="customer_id"
              :items="customers"
              label="Paciente"
              hide-details
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              @change="handleSelectCustomer"
              :filter="customFilter"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.fullname
                  }}</v-list-item-title>
                  <v-list-item-subtitle v-if="data.item.type_document_id">
                    {{ data.item.type_document.name }}: {{ data.item.document }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete> -->
          </v-col>
          <v-col cols="1" class="pl-0" v-if="customer == null">
            <v-icon
              color="success"
              class="mt-2"
              @click="handleViewCreateCustomer"
            >
              fas fa-plus-circle
            </v-icon>
          </v-col>
        </v-row>

        <v-row class="pl-3 pr-3" v-if="customer">
          <v-col cols="12" class="pt-0 pb-0">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="green" class="mr-2" size="18">
                      fas fa-user-tag
                    </v-icon>
                    <span
                      class="
                        text-uppercase
                        font-weight-bold
                        cart-label-customer
                      "
                      >{{ customer.fullname }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="ml-8"
                      >{{ customer.type_document.name }}:
                      {{ customer.document }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <span class="ml-8"
                      >Fecha Nacimiento: {{ customer.born_date }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <span class="ml-8"
                      >Edad: {{ calcula_edad(customer.born_date) }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <span class="ml-8">Sexo: {{ customer.gender }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearCustomer" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <!--Fin Paciente-->

        <hr class="separator-line" />

        <!--Inicio médico-->
        <v-row class="pl-3 pr-3">
          <v-col cols="11" class="pb-3" v-if="doctor == null">
            <v-autocomplete
              ref="doctor_id"
              :items="doctors"
              label="Médico"
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              :value="doctor_id"
              :loading="isLoadingMedico"
              @change="handleSelectDoctor"
              :filter="customFilter"
              v-on:keyup.enter="searchMedico($event)"
              hide-details="auto"
              required
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.fullname
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    DNI: {{ data.item.document }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <!-- <v-autocomplete
              :value="doctor_id"
              :items="doctors"
              label="Médico"
              hide-details
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              @change="handleSelectDoctor"
              :filter="customFilter"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.fullname
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    DNI: {{ data.item.document }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete> -->
          </v-col>
          <v-col cols="1" class="pl-0" v-if="doctor == null">
            <v-icon
              color="success"
              class="mt-2"
              @click="handleViewCreateDoctor"
            >
              fas fa-plus-circle
            </v-icon>
          </v-col>
        </v-row>

        <v-row class="pl-3 pr-3" v-if="doctor">
          <v-col cols="12" class="pt-0 pb-0">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="green" class="mr-2" size="18">
                      fas fa-user-tag
                    </v-icon>
                    <span
                      class="
                        text-uppercase
                        font-weight-bold
                        cart-label-customer
                      "
                      >{{ doctor.fullname }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="ml-8">DNI: {{ doctor.document }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearDoctor" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <!--Fin médico-->

        <hr class="separator-line" />

        <!--Inicio Empresa-->
        <v-row class="pl-3 pr-3">
          <v-col cols="11" class="pb-4" v-if="company == null">
            <v-autocomplete
              ref="company_id"
              :items="companies"
              label="Convenio / Empresa"
              outlined
              item-text="name"
              item-value="id"
              clearable
              :value="company_id"
              :loading="isLoadingCompanie"
              @change="handleSelectCompany"
              :filter="customFilter"
              v-on:keyup.enter="searchCompany($event)"
              hide-details="auto"
              required
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    RUC: {{ data.item.ruc }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <!-- <v-autocomplete
              :value="company_id"
              :items="companies"
              label="Convenio"
              hide-details
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              @change="handleSelectCompany"
              :filter="customFilter"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    RUC: {{ data.item.ruc }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete> -->
          </v-col>

          <v-col cols="1" class="pl-0" v-if="company == null">
            <v-icon
              color="success"
              class="mt-2"
              @click="handleViewCreateCompany"
            >
              fas fa-plus-circle
            </v-icon>
          </v-col>
        </v-row>

        <v-row class="pl-3 pr-3" v-if="company">
          <v-col cols="12" class="pt-0 pb-0">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="green" class="mr-2" size="18">
                      fas fa-user-tag
                    </v-icon>
                    <span
                      class="
                        text-uppercase
                        font-weight-bold
                        cart-label-customer
                      "
                      >{{ company.name }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="ml-8"> RUC: {{ company.ruc }} </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearCompany" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <!--Fin Empresa-->

        <hr class="separator-line" />

        <v-row style="height: 41% !important">
          <v-col cols="12" class="pt-1 pb-1">
            <template>
              <div class="section-list-items-cart">
                <v-list
                  dense
                  two-line
                  class="list-cart-items pt-0 pb-0"
                  style="height: 100% !important"
                >
                  <v-list-item
                    v-for="(product, index) in cart"
                    :key="product.id"
                    class="cart-item pl-2 pr-2"
                  >
                    <v-list-item-content
                      class="pt-0 pb-0 cart-item-content"
                      @click="hanldleClickItemCart(product)"
                    >
                      <!--<v-list-item-content class="pt-0 pb-0 cart-item-content">-->
                      <v-list-item-title>
                        <span class="text-uppercase font-weight-bold">
                          {{ product.code }} - {{ product.description }}
                        </span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <span class="cart-item-quantity">
                          {{ product.quantity }}
                        </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action class="mb-1 cart-item-action">
                      <v-list-item-action-text>
                        <span
                          v-if="product.discount_value"
                          class="font-weight-bold mr-2"
                        >
                          {{
                            getAmountProductDiscount(product) | currency("S/")
                          }}
                        </span>
                        <span v-else class="font-weight-bold mr-2">{{
                          product.price | currency("S/")
                        }}</span>

                        <span
                          @click="handleDeleteItem(product, index)"
                          class="cart-item-delete"
                        >
                          <v-icon size="18" color="red">fas fa-times</v-icon>
                        </span>
                        <v-icon
                          v-if="product.is_bonus"
                          size="18"
                          class="ml-2"
                          color="green"
                          @click="handleChangeBonus(product)"
                        >
                          fas fa-gift
                        </v-icon>
                        <v-icon
                          v-else
                          size="18"
                          class="ml-2"
                          color="grey lighten-1"
                          @click="handleChangeBonus(product)"
                        >
                          fas fa-gift
                        </v-icon>
                      </v-list-item-action-text>
                      <v-list-item-action-text
                        v-if="
                          product.discount_value && product.discount_value > 0
                        "
                      >
                        <span
                          class="label-amount-original label-price-discounted"
                        >
                          {{ product.subtotal | currency("S/") }}
                        </span>
                      </v-list-item-action-text>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </div>
            </template>
          </v-col>
        </v-row>
        <hr class="separator-line" />

        <v-row>
          <v-col cols="12" class="pt-0 pb-0">
            <v-list class="pt-0">
              <v-list-item class="amount-summary">
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title>
                    <span class="font-weight-bold label-discount"
                      >DESCUENTO</span
                    >
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="mt-1 mb-1">
                  <span class="font-weight-bold label-discount">{{
                    discount | currency("S/")
                  }}</span>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>

              <v-list-item class="amount-summary">
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title>
                    <span class="font-weight-bold">SUBTOTAL</span>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="mt-1 mb-1">
                  <span class="font-weight-bold">{{
                    subtotal | currency("S/")
                  }}</span>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>

              <v-list-item class="amount-summary">
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title>
                    <span class="font-weight-bold">IGV</span>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="mt-1 mb-1">
                  <span class="font-weight-bold">{{
                    igv | currency("S/")
                  }}</span>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>

              <v-list-item class="amount-summary">
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title>
                    <span class="font-weight-bold">TOTAL</span>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="mt-1 mb-1">
                  <span class="font-weight-bold">{{
                    total | currency("S/")
                  }}</span>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <v-row justify="center" v-if="!selected_station">
          <v-row class="pl-3 pr-3">
            <v-col cols="4" class="pt-0 pl-6">
              <v-btn
                block
                dark
                color="red"
                height="45"
                @click="handleShowListRequest"
              >
                CANCELAR
              </v-btn>
            </v-col>
            <v-col cols="8" class="pt-0 pr-6">
              <v-btn
                block
                dark
                color="green"
                height="45"
                @click="handleShowPayment"
              >
                PAGAR {{ total | currency("S/") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-row>

        <v-row justify="center" v-else>
          <v-col cols="4" class="pt-0">
            <v-btn
              dark
              block
              color="blue"
              height="45"
              @click="handleSaveSale"
              :loading="processing"
            >
              GUARDAR
            </v-btn>
          </v-col>

          <v-col cols="7" class="pt-0" v-if="sale_station">
            <v-btn
              dark
              block
              color="green"
              height="45"
              @click="handleShowPayment"
            >
              PAGAR {{ total | currency("S/") }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card-text>

    <Payment ref="payment"></Payment>

    <Prices ref="Prices"></Prices>

    <create-update ref="CreateUpdate"></create-update>
    <create-update-doctor ref="CreateUpdateDoctor"></create-update-doctor>
    <create-update-company ref="CreateUpdateCompany"></create-update-company>

    <v-snackbar v-model="cant_pay" top color="error">
      {{ message_validation }}
      <v-btn dark text @click="handleCloseMessageValidation"> Cerrar </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import router from "@/router/index";
import ArrayTools from "../../helpers/ArrayTools";
import Payment from "../../components/sales/Payment";
import Prices from "../../components/sales/Prices";
import CreateUpdate from "../../components/customers/CreateUpdate";
import CreateUpdateDoctor from "../../components/doctors/CreateUpdate";
import CreateUpdateCompany from "../../components/companies/CreateUpdate";
import { LoadingSpinner } from "../../helpers/Spinner/Loading.spinner";

export default {
  name: "Patient",
  components: {
    Payment,
    Prices,
    CreateUpdate,
    CreateUpdateDoctor,
    CreateUpdateCompany,
  },
  data() {
    return {
      menuDateInvoice: false,
      cant_pay: false,
      message_validation: null,
      processing: false,
      last_order_code_solicitud: null,
      isLoading: false,
      isLoadingMedico: false,
      isLoadingCompanie: false,
    };
  },
  computed: {
    ...mapState("authentication", ["office_id"]),
    ...mapState("customers", ["customers"]),
    ...mapState("doctors", ["doctors"]),
    ...mapState("companies", ["companies"]),
    ...mapState("employees", ["workers"]),
    ...mapState("sales", [
      "cart",
      "subtotal",
      "igv",
      "total",
      "customer",
      "customer_id",
      "doctor",
      "doctor_id",
      "company",
      "company_id",
      "product",
      "discount",
      "type_operation",
      "date_invoice",
      "sale_station",
      "worker",
      "worker_id",
      "rounding",
      "total_rounded",
      "total_gratuitas",
      "last_order_code",
      "document_active",
      "solicitud",
    ]),
    ...mapState("stations", ["selected_station"]),
    ...mapState("clients", ["clients"]),
  },
  methods: {
    handleShowListRequest() {
      //this.router('/app/atencion/solicitud-analisis');
      this.clearData();
      router.push("/app/atencion/solicitud-analisis");
    },
    ...mapMutations("sales", ["set_date_invoice"]),
    ...mapActions("customers", ["getCustomers", "setCustomers"]),
    ...mapActions("doctors", ["getDoctors", "setDoctors"]),
    ...mapActions("companies", ["getCompanies", "setCompanies"]),
    ...mapActions("employees", ["getWorkers"]),
    ...mapActions("clients", ["getClients", "setClients"]),
    ...mapActions("sales", [
      "run_set_cart",
      "replace_product_cart",
      "delete_product_cart",
      "clearAmount",
      "select_customer",
      "select_doctor",
      "select_company",
      "clearData",
      "run_set_sale",
      "setViewPrices",
      "select_product",
      "setTypeOperation",
      "setDateInvoice",
      "selectWorker",
      "storeByStation",
      "updateByStation",
      "getLastOrderCode",
      "select_is_client",
      "select_client",
      "select_document_active",
      "calulateAmounts",
      "getSolicitudByOrder",
      "run_set_reset_data_with_solicitud",
    ]),
    customTextPaciente(item) {
      let text = item.surname + " " + item.name;
      return text;
    },
    customText(item) {
      let text = item.fullname;

      return text;
    },
    customTextWorkers(item) {
      let text = item.fullname;

      return text;
    },
    handleSelectCustomer(value) {
      if (value == null || value == undefined) {
        this.select_customer(null);
      } else {
        let selected_customer = ArrayTools.getElementById(
          this.customers,
          value
        );
        this.select_customer(selected_customer);
      }
    },
    calcula_edad(fecha_nac) {
      let edad = ArrayTools.calcula_edad(fecha_nac);
      return edad;
    },
    handleSelectDoctor(value) {
      if (value == null || value == undefined) {
        this.select_doctor(null);
      } else {
        let selected_doctor = ArrayTools.getElementById(this.doctors, value);
        this.select_doctor(selected_doctor);
      }
    },
    handlePriceConvenio(cart, company_id) {
      let newCart = [];
      if (cart) {
        cart.forEach((value) => {
          if (value.detail_price.length > 0) {
            const service_price = value.detail_price.find(
              (dtp) => dtp.company_id == company_id
            );
            if (service_price) {
              let item = Object.assign({}, value);
              item.price_aux = item.price;
              item.price = parseFloat(service_price.price);
              newCart.push(item);
            } else {
              value.price_aux = value.price;
              newCart.push(value);
            }
          } else {
            value.price_aux = value.price;
            newCart.push(value);
          }
        });
      }
      this.run_set_cart(newCart);
    },
    handlePriceBase(cart) {
      let newCart = [];
      if (cart) {
        cart.forEach((value) => {
          let item = Object.assign({}, value);
          item.price = value.monto_base;
          newCart.push(item);
          // if (value.monto_convenio > 0) {
          //   let item = Object.assign({}, value);
          //   item.price = value.monto_base;
          //   newCart.push(item);
          // } else {
          //   newCart.push(value);
          // }
        });
      }
      this.run_set_cart(newCart);
    },
    handleSelectCompany(value) {
      if (value == null || value == undefined) {
        this.select_company(null);
        this.calulateAmounts();
      } else {
        let selected_company = ArrayTools.getElementById(this.companies, value);
        this.select_company(selected_company);
        // this.select_client(selected_company);
        // this.select_document_active("true");
        this.select_is_client(false);
        // ? agregar el precio convenio automaticamente
        this.handlePriceConvenio(this.cart, value);
        this.calulateAmounts();
      }
    },

    handleSelectWorker(value) {
      if (value == null || value == undefined) {
        //this.customer_id = null;
        this.selectWorker(null);
      } else {
        let selected_worker = ArrayTools.getElementById(this.workers, value);
        this.selectWorker(selected_worker);
      }
    },
    handleClearCustomer() {
      //this.customer_id = null
      this.select_customer(null);
    },
    handleClearDoctor() {
      //this.customer_id = null
      this.select_doctor(null);
    },
    handleClearCompany() {
      this.handlePriceBase(this.cart);
      this.calulateAmounts();
      this.select_company(null);
    },
    handleClearWorker() {
      this.selectWorker(null);
    },
    handleDeleteItem(product, index) {
      // console.log(product, index)
      this.delete_product_cart({ product, index });
    },
    handleCloseMessageValidation() {
      this.cant_pay = false;
      this.message_validation = null;
    },
    handleShowPayment() {
      // if (this.company) {
      //   this.select_client(this.company);
      //   this.select_document_active("true");
      // }
      if (this.customer_id == null) {
        this.cant_pay = true;
        this.message_validation = "Debe seleccionar un paciente.";
      } else if (this.cart.length == 0) {
        /*else if (this.doctor == null) {
                this.cant_pay = true;
                this.message_validation = 'Debe seleccionar un médico.';
            } */
        this.cant_pay = true;
        this.message_validation = "Debe seleccionar al menos un análisis.";
      } else {
        if (this.type_operation === "sale") {
          this.$refs.payment.showForm("Registro de pago de venta", true);
        } else {
          this.$refs.payment.showForm("Registro de pago de pedido", true);
        }
      }
    },
    hanldleClickItemCart(product) {
      this.select_product(product);
      // console.log(product);
      this.setViewPrices(true);
    },
    handleChangeTypeOperation(value) {
      this.setTypeOperation(value);
      this.clearData();
    },
    getAmountProductDiscount(product) {
      let amount = 0;
      let subtotal = Math.round(product.subtotal * 100) / 100;
      let discount = Math.round(product.discount_value * 100) / 100;
      amount = Math.round((subtotal - discount) * 100) / 100;
      // console.log(product);
      return amount;
    },
    handleChangeBonus(product) {
      let productItem = Object.assign({}, product);
      productItem.is_bonus = !productItem.is_bonus;
      this.replace_product_cart(productItem);
    },
    handleViewCreateCustomer() {
      this.$refs.CreateUpdate.showForm("Nuevo Paciente", "create");
    },
    handleViewCreateDoctor() {
      this.$refs.CreateUpdateDoctor.showForm("Nuevo Médico", "create");
    },
    handleViewCreateCompany() {
      this.$refs.CreateUpdateCompany.showForm("Nueva Empresa", "create");
    },
    async handleSaveSale() {
      this.processing = true;
      if (this.customer == null) {
        this.cant_pay = true;
        this.message_validation = "Debe seleccionar un cliente.";
        this.processing = false;
      } else if (this.doctor == null) {
        this.cant_pay = true;
        this.message_validation = "Debe seleccionar un Médico.";
        this.processing = false;
      } else if (this.company == null) {
        this.cant_pay = true;
        this.message_validation = "Debe seleccionar una empresa";
        this.processing = false;
      } else if (this.cart.length == 0) {
        this.cant_pay = true;
        this.message_validation = "Debe seleccionar al menos un producto.";
        this.processing = false;
      } else {
        let sale = this.setEntitySale();
        if (this.sale_station == null) {
          await this.storeByStation(sale);
        } else {
          await this.updateByStation(sale);
        }
        this.processing = false;
      }
    },
    setEntitySale() {
      let sale = {
        office_id: this.office_id,
        id: this.sale_station,
        date_invoice: this.date_invoice,
        worker_id: this.worker_id,
        customer_id: this.customer_id,
        doctor_id: this.doctor_id,
        company_id: this.company_id,
        type_operation: this.type_operation,
        products: this.cart,
        discount: this.discount,
        subtotal: this.subtotal,
        igv: this.igv,
        total: this.total,
        rounding: this.rounding,
        total_rounded: this.total_rounded,
        total_gratuitas: this.total_gratuitas,
        station_id: this.selected_station.id,
      };

      return sale;
    },
    customFilter(item, queryText, itemText) {
      // console.log(item);
      let textName = "";
      if (item.name) {
        if (item.fullname) {
          textName = item.fullname.toLowerCase();
        } else {
          textName = item.name.toLowerCase();
        }
      }
      let textDocument = "";
      if (item.document) {
        textDocument = item.document.toLowerCase();
      }
      let searchText = queryText.toLowerCase();

      return (
        textName.indexOf(searchText) > -1 ||
        textDocument.indexOf(searchText) > -1
      );
    },
    async loadFist() {
      // await this.getLastOrderCode();
      // console.log(this.last_order_code);
    },
    async handleInputSearchOrderCode(KeyboardEvent) {
      if (KeyboardEvent.code == "Enter") {
        if (this.last_order_code_solicitud) {
          LoadingSpinner.Circle();

          let filterService = {
            order: this.last_order_code_solicitud,
          };
          await this.getSolicitudByOrder(filterService);
          const solicitud = this.solicitud;

          if (solicitud.customer) {
            if (!this.customers.find((dt) => dt.id == solicitud.customer.id)) {
              this.setCustomers([...this.customers, solicitud.customer]);
            }
          }
          if (solicitud.doctor) {
            if (!this.doctors.find((dt) => dt.id == solicitud.doctor.id)) {
              this.setDoctors([...this.doctors, solicitud.doctor]);
            }
          }
          if (solicitud.client) {
            if (!this.clients.find((dt) => dt.id == solicitud.client.id)) {
              this.setClients([...this.clients, solicitud.client]);
            }
          }
          if (solicitud.companyCustomer) {
            if (
              !this.companies.find(
                (dt) => dt.id == solicitud.companyCustomer.id
              )
            ) {
              this.setCompanies([...this.doctors, solicitud.companyCustomer]);
            }
          }

          if (solicitud && !solicitud.custom_error && solicitud?.id) {
            this.run_set_reset_data_with_solicitud(solicitud);

            if (solicitud.customer_id) {
              const returnCustomer = this.customers.find(
                (dt) => dt.id == solicitud.customer_id
              );
              if (returnCustomer) this.select_customer(returnCustomer);
            }

            if (solicitud.company_customer_id) {
              const returnCompany = this.companies.find(
                (dt) => dt.id == solicitud.company_customer_id
              );
              if (returnCompany) this.select_company(returnCompany);
            }

            if (solicitud.doctor_id) {
              const returnDoctor = this.doctors.find(
                (dt) => dt.id == solicitud.doctor_id
              );
              if (returnDoctor) this.select_doctor(returnDoctor);
            }

            if (solicitud.client_id) {
              const returnClient = this.clients.find(
                (dt) => dt.id == solicitud.client_id
              );
              if (returnClient) {
                this.select_client(returnClient);
              }
            }

            // this.calulateAmounts();
            // this.run_set_customer_id(solicitud.customer_id);
            // this.run_set_doctor_id(solicitud.doctor_id);
            // this.run_set_company_id(solicitud.company_id);
            // this.cart = solicitud.detail;
            // this.discount = solicitud.discount;
            // this.subtotal = solicitud.subtotal;
            // this.igv = solicitud.igv;
            // this.total = solicitud.total;
            // this.rounding = solicitud.rounding;
            // this.total_rounded = solicitud.total_rounded;
            // this.total_gratuitas = solicitud.total_gratuitas;
          }
          LoadingSpinner.Remove();
        }
      }
    },
    async searchPaciente(event) {
      this.isLoading = true;
      const value = event.target.value;
      if (value.length > 0) {
        let filters = {};
        if (!isNaN(value)) filters = { ...filters, document: value };
        else filters = { ...filters, fullname: value };
        await this.getCustomers({ ...filters, active: true });
      } else {
        await this.getCustomers();
      }
      this.isLoading = false;
    },
    async searchMedico(event) {
      this.isLoadingMedico = true;
      const value = event.target.value;
      if (value.length > 0) {
        let filters = {};
        if (!isNaN(value)) filters = { ...filters, document: value };
        else filters = { ...filters, fullname: value };
        await this.getDoctors({ ...filters, active: true });
      } else {
        await this.getDoctors();
      }
      this.isLoadingMedico = false;
    },
    async searchCompany(event) {
      this.isLoadingCompanie = true;
      const value = event.target.value;
      if (value.length > 0) {
        let filters = {};
        if (!isNaN(value)) filters = { ...filters, document: value };
        else filters = { ...filters, fullname: value };
        await this.getCompanies({ ...filters, active: true });
      } else {
        await this.getCompanies();
      }
      this.isLoadingCompanie = false;
    },
  },
  created() {
    this.setTypeOperation("sale");
    if (!this.selected_station) {
      this.setDateInvoice(this.$moment().format("YYYY-MM-DD"));
    }
    this.loadFist();
    this.clearData();
  },
  mounted() {
    this.getCustomers({ active: true });
    this.getDoctors();
    this.getCompanies();
    let filters = {
      office_id: this.office_id,
    };
    // this.getWorkers(filters);
    if (!this.selected_station) {
      this.run_set_cart([]);
      // this.clearData();
      this.run_set_sale(null);
    }
  },
};
</script>

<style scoped>
.label-discount {
  color: #f44336;
}

.amount-summary {
  min-height: 30px !important;
}

.list-cart-items {
  overflow-y: auto;
}

.label-amount-original {
  display: block !important;
}

.v-list-item__action-text {
  font-size: 0.85rem !important;
}

.label-price-discounted {
  text-decoration: line-through;
  text-decoration-color: #c62828;
}

.section-list-items-cart {
  height: 35vh;
  overflow-y: auto;
}

.cart-item-content {
  cursor: pointer;
}
</style>
